import { Injectable } from '@angular/core';
import { ApiService } from '@core/services/api.service';
import { LeadSourceTag } from '@shared/models/lead-source-tag';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LeadSourceTagsApiService {
  constructor(private apiService: ApiService) {}

  index(): Observable<{ data: LeadSourceTag[] }> {
    return this.apiService.get('v1/lead_source_tags');
  }

  create(lead_source_tag: Partial<LeadSourceTag>): Observable<{ data: LeadSourceTag }> {
    return this.apiService.post('v1/lead_source_tags', { data: lead_source_tag });
  }
}
